import { appUrl, toURLSearchParams } from "utils";
export function tourDetailsUrl(tourId, options, frameId) {
    const [baseUrl, q] = tourDetailsUrlImpl(tourId, options, frameId);
    return appUrl(baseUrl, q) + (options.anchor ? `${options.anchor}` : '');
}
export function tourDetailsUrlRR(tourId, options, frameId) {
    const [baseUrl, q] = tourDetailsUrlImpl(tourId, options, frameId);
    const usp = toURLSearchParams(q);
    return { pathname: appUrl(baseUrl), search: usp.toString(), state: options.state, hash: options.anchor, };
}
function tourDetailsUrlImpl(tourId, options, frameId) {
    var _a;
    const slug = (_a = options.tourName) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase().replace(/[^\wа-яё ]+/gu, '').replace(/\s+/gu, '-');
    const baseUrl = (frameId ? `/frame/${frameId}` : '') + (options.hash ? `/Tour/${tourId}/view/${options.hash}` : `/Tour/${tourId}`) + (slug ? '/' + slug : '');
    const q = {};
    if (options.variantId)
        q['variant'] = options.variantId;
    if (options.accmmdId)
        q['accmmd'] = !Array.isArray(options.accmmdId) || options.accmmdId.length > 1 ? options.accmmdId : options.accmmdId[0];
    if (options.excursions && options.excursions.length > 0)
        q['exc'] = options.excursions.map(e => `${e.serviceId}=${(e.vehicleTypeId == undefined ? '' : e.vehicleTypeId)}`).reduce((pr, curr) => `${pr};${curr}`);
    if (options.externalFlight) {
        q['fId'] = options.externalFlight.flightId;
        q['fpId'] = options.externalFlight.providerId;
    }
    if (options.useExtrasFromCart) {
        q['useExtrasFromCart'] = 'true';
    }
    if (options.search) {
        q['search'] = options.search;
    }
    if (options.extras) {
        //Object.keys(options.extras).filter(key => options.extras![key]?.length).forEach((key) => {
        //    q[`extras[${key}]`] = options.extras![key];
        //});
    }
    if (options.separatedFlights) {
        for (let i = 0; i < options.separatedFlights.length; i++) {
            q[`separatedFlights[${i}][serviceId]`] = options.separatedFlights[i].serviceId;
            q[`separatedFlights[${i}][providerId]`] = options.separatedFlights[i].providerId;
            q[`separatedFlights[${i}][flightId]`] = options.separatedFlights[i].flightId;
        }
    }
    return [baseUrl, q];
}
//export const useTourUrlgen = (isFrame: boolean = false): {
//    tourDetailsUrl: ((tourId: number, options: {
//        accmmdId?: string,
//        variantId?: string,
//        tourName?: string,
//    }, frameId?: string) => string),
//    tourDetailsUrlRR: ((tourId: number, options: {
//        accmmdId?: string,
//        variantId?: string,
//        tourName?: string,
//        state?: any,
//        excursions?: {
//            id: number,
//            vehicleTypeId?: number
//        }[],
//    }, frameId?: string) => { pathname: string, search: string, state: any })
//} => {
//    if (!isFrame)
//        return { tourDetailsUrl: tourDetailsUrl, tourDetailsUrlRR: tourDetailsUrlRR };
//    else
//        return { tourDetailsUrl: tourDetailsUrl, tourDetailsUrlRR: tourDetailsUrlRR };
//}
